// Firebase bootstrap.
// Sets window globals consumed by App.tsx. Must execute before App.tsx imports.
// Ported from the <script type="module"> block in bishopric-complete/index.html
// that previously loaded Firebase from https://www.gstatic.com CDN.

import { initializeApp } from 'firebase/app'
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from 'firebase/auth'
import {
  initializeFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  collection,
  query,
  where,
  onSnapshot,
  runTransaction,
} from 'firebase/firestore'
import { createApiClient } from '@leadership/api-client'

const app = initializeApp({
  apiKey: 'AIzaSyCM4O46FyllfX2ejovfvWTyh573ov0hx4E',
  authDomain: 'driggs-idaho-stake.firebaseapp.com',
  projectId: 'driggs-idaho-stake',
  storageBucket: 'driggs-idaho-stake.firebasestorage.app',
  messagingSenderId: '327671154622',
  appId: '1:327671154622:web:be073fda12e9ae81fc1bef',
})

window.firebaseAuth = getAuth(app)
// `ignoreUndefinedProperties: true` makes setDoc/updateDoc silently drop
// fields whose value is `undefined` instead of throwing. Brings web in line
// with mobile (which strips undefined inside its createDb helper) and
// prevents the whole class of "Function setDoc() called with invalid data.
// Unsupported field value: undefined" errors that have been popping up as
// we add features that conditionally include optional fields.
window.firebaseDb = initializeFirestore(app, { ignoreUndefinedProperties: true })
window.GoogleAuthProvider = GoogleAuthProvider
window.signInWithPopup = signInWithPopup
window.signOut = signOut
window.onAuthStateChanged = onAuthStateChanged
window.signInWithEmailAndPassword = signInWithEmailAndPassword
window.sendPasswordResetEmail = sendPasswordResetEmail
window.firestoreDoc = doc
window.firestoreGetDoc = getDoc
window.firestoreSetDoc = setDoc
window.firestoreDeleteDoc = deleteDoc
window.firestoreUpdateDoc = updateDoc
window.firestoreCollection = collection
window.firestoreQuery = query
window.firestoreWhere = where
window.firestoreOnSnapshot = onSnapshot
// Firestore transactions — used by db.patch for read-modify-write
// updates that are safe under concurrent edits (multiple stake
// admins editing a meeting agenda at the same time, etc.). Without
// this, two clients writing the same doc could clobber each other.
window.firestoreRunTransaction = runTransaction

const IS_DEV = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

window.API_BASE_URL = IS_DEV
  ? 'http://localhost:5001/driggs-idaho-stake/us-central1/api'
  : 'https://us-central1-driggs-idaho-stake.cloudfunctions.net/api'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').then((reg) => {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && reg) reg.update()
    })
  })
}

// All auth'd API traffic routes through the shared client. `window.apiRequest`
// stays on `window` as a back-compat shim for the dozens of legacy call sites
// in App.tsx + stake views that still reach for it directly.
const apiClient = createApiClient({
  baseUrl: window.API_BASE_URL,
  getToken: () => window.firebaseAuth.currentUser?.getIdToken() ?? null,
})

window.apiRequest = apiClient.request
